import axios from "axios";
import baseUrl from "./baseURL";

const request = (method, url, data, headers = {}) => {
  const token = localStorage.getItem("token");

  return axios({
    method,
    url,
    data,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      ...headers,
    },
  }).catch((e) => {
    console.log({ e });
    const status = e.response?.status;
    const refresh_token = localStorage.getItem("refresh_token");

    if (status === 401) {
      // try to refresh the token
      if(refresh_token){
        return axios({
          method: "get",
          url: baseUrl + "/auth/refresh_token",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
            refresh_token: refresh_token,
          },
        })
        .then((res) => {
          localStorage.setItem("token", res?.data?.access_token);
        })
        .catch((ee) => {
          localStorage.clear();
          window.location = "/";
        });
      }
      else{
        localStorage.clear();
      }
    }
    else if (status === 429) {
      throw status;
    }
    
    throw e;
  });
};

export const loginAction = (username, password) => {
  const bodyFormData = new FormData();

  bodyFormData.append("username", username);
  bodyFormData.append("password", password);

  return request("post", baseUrl + "/auth/login", bodyFormData, {
    "Content-Type": "application/x-www-form-urlencoded",
  }).then((res) => {
    if (res.status === 200) {
      localStorage.setItem("userId", res?.data?.user_id);
      localStorage.setItem("token", res?.data?.access_token);
      localStorage.setItem("refresh_token", res?.data?.refresh_token);

      // get user data
      request("get", baseUrl + "/users/" + res?.data?.user_id).then((user) => {
        localStorage.setItem("email", user?.data?.email);
      });
    }
    return res;
  });
};

export const createProject = (data) => {
  return request("post", baseUrl + "/projects/", data);
};

export const uploadProjectFile = (taskId, taskType, ovidfile) => {
  const token = localStorage.getItem("token");

  return request(
    "put",
    `${baseUrl}/tasks/${taskId}/task_type/${taskType}/data/ovid`,
    {
      ovidfile,
    },
    {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    }
  );
};

export const addTask = (task_type, workstream_id) => {
  return request("post", baseUrl + "/tasks", {
    task_type,
    workstream_id
  });
};

export const addWorkstream = (project_id, workstream_type) => {
  return request("post", baseUrl + "/workstreams", {
    project_id, 
    workstream_type
  });
};

export const getProjects = (activeOnly = true) => {
  return request("get", baseUrl + "/projects/list?active_only=" + activeOnly);
};

export const inviteUser = (projectId, email, role) => {
  const data = {
    [role]: [email]
  }
  
  return request("post", baseUrl + "/projects/" + projectId + "/permissions", data);
};

export const getProjectUsers = (projectId) => {
  return request("get", baseUrl + "/projects/" + projectId + "/list_permitted_users/");
};


export const restoreProject = (projectId) => {
  return request("post", baseUrl + "/projects/" + projectId + "/reactivate");
};

export const getProjectDetails = (id) => {
  return request("get", baseUrl + "/projects/" + id);
};

export const getTaskDetails = (taskId, taskType = "Abstract Screening") => {
  return request("get", baseUrl + "/tasks/" + taskId + "/task_type/" + taskType);
};

export const changePasswordRequest = (password, confirm_password, current_password) => {
  const userId = localStorage.getItem("userId");

  return request("put", baseUrl + "/users/" + userId + '/password', {
    password,
    confirm_password,
    current_password
  }).then(res => {
    // update user tokens
    localStorage.setItem("token", res?.data?.access_token);
    localStorage.setItem("refresh_token", res?.data?.refresh_token);
  });
};

export const resetPasswordRequest = (email) => {
  return request("post", baseUrl + "/users/reset_password_email?email=" + email)
};

export const sessionCheck = () => {
  return request("get", baseUrl + "/session_check");
};

export const initScreening = (taskId, taskType, screeningData, query) => {
  return request(
    "post",
    `${baseUrl}/tasks/${taskId}/task_type/${taskType}/screening${query ? ("?" + query) : ""}`,
    { ...screeningData }
  );
};

export const getResults = (project_id) => {
  return request(
    "get",
    baseUrl + "/projects/" + project_id + "/screening/results"
  );
};

export const getSummary = (task_id, task_type = "Abstract Screening") => {
  return request(
    "get",
    `${baseUrl}/tasks/${task_id}/task_type/${task_type}/screening/summary`
  );
};

export const deleteProject = (project_id) => {
  return request("patch", 
    baseUrl + "/projects/" + project_id + '/softdelete'
  );
};

// export const deleteTask = (task_id, task_type) => {
//   return request("put", 
//     baseUrl + "/tasks/" + task_id + "/task_type/" + task_type + "/deactivate"
//   );
// };

export const deleteWorkstream = (workstream_id) => {
  return request("delete", 
    baseUrl + "/workstreams/" + workstream_id
  );
};

export const getFieldsValues = (project_id) => {
  return request(
    "get",
    baseUrl + "/projects/" + project_id + "/screening/screening_data"
  );
};

export const getConcepts = (task_id, task_type, COAAI_Ids=[]) => {
  const ids = COAAI_Ids.length ? "?COAAI_Ids=" + COAAI_Ids.join('&COAAI_Ids=') : null
  return request(
    "get",
    `${baseUrl}/tasks/${task_id}/task_type/${task_type}/screening/mapped_concepts${ids || ""}`
  ).then((res) => {
    const concepts = res?.data?.ai_concepts?.reduce((acc, curr, ndx) => {
      if (curr.parent_concept) {
        acc.push({
          ...curr,
          id: ndx,
          Concepts: curr.Concepts.trim(),
          children: [],
        });
      } else {
        acc[acc.length - 1].children.push({
          ...curr,
          id: ndx,
          Concepts: curr.Concepts.trim(),
        });
      }
      return acc;
    }, []);
    return concepts;
  }).catch(e => {
    return []
  });
};

export const addArticle = (articleId, file) => {
  const token = localStorage.getItem("token");

  return request(
    "put",
    `${baseUrl}/tasks/article/${articleId}`,
    {
      article: file,
    },
    {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    }
  );
};


export const getArticles = (task_id, task_type) => {
  return request(
    "get",
    baseUrl + "/tasks/" + task_id + "/task_type/" + task_type + "/articles_links"
  );
}

export const getReport = (task_id, task_type, filters = [], researcher_file = false) => {
  const token = localStorage.getItem("token");
  const searchParams = new URLSearchParams();

  filters.forEach((id) => searchParams.append("COAAI_Ids", id));
  searchParams.append("researcher_file", researcher_file);

  const queryString = searchParams.toString() ? `?${searchParams.toString()}` : "";
  const reportUrl = `${baseUrl}/tasks/${task_id}/task_type/${task_type}/screening/report${queryString}`;

  return request(
    "get",
    reportUrl,
    undefined,
    { accept: "*/*" }
  ).then((fileInfo) => {
    return fetch(reportUrl, {
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        accept: "*/*",
      }),
    }).then((res) => {
      const data = res.blob();
      return { infos: fileInfo, data };
    });
  });
};

export const logoutAction = () => {
    const refresh_token = localStorage.getItem("refresh_token");
    const token = localStorage.getItem("token");

    return axios({
      method: "get",
      url: baseUrl + "/auth/logout",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        refresh_token: refresh_token,
      },
    })
    .then((res) => {
      localStorage.clear();
      window.location = "/";
      return res
    })
    .catch((ee) => {
      localStorage.clear();
      window.location = "/";
    });
};
